import {
  Box,
  Divider,
  Flex,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { IoLogoJavascript } from "react-icons/io5";
import { IoLogoReact } from "react-icons/io5";
import { SiMysql, SiNextdotjs, SiPhp, SiTypescript } from "react-icons/si";
import { SiChakraui } from "react-icons/si";
import { IoLogoHtml5 } from "react-icons/io5";
import { FaCss3 } from "react-icons/fa6";
import { SiTailwindcss } from "react-icons/si";
import { SiRedux } from "react-icons/si";
import { FaNodeJs } from "react-icons/fa";
import { SiMongodb } from "react-icons/si";
import { TbBrandReactNative } from "react-icons/tb";
export const About = () => {
  return (
    <Box bg={"#17181A"} h="auto" id="about">
      <Flex
        flexDirection={{ base: "column", md: "row" }}
        justifyContent={"space-between"}
        py="20"
        px={{ base: "10", md: "28" }}
        gap={{ base: "10", md: "auto" }}
      >
        <Box>
          <Text fontSize={"5xl"} fontWeight={"medium"} color="white">
            About Me
          </Text>
          <Divider border="2px solid #F0451A" width={"20"} />
          <Text mt="5" maxW="xl" color="white" fontSize={"sm"}>
            I am genuinely passionate about Frontend Development and Technical
            Writing and thrive on tackling challenges that push my skills to new
            heights. My dedication to staying current with emerging trends and
            technologies allows me to bring fresh perspectives to my work,
            ensuring that the solutions I provide are both innovative and
            effective.
          </Text>
        </Box>
        <Box>
          <Text fontSize={"2xl"} fontWeight={"medium"} color="white">
            My Tools
          </Text>
          {/* <Divider mt='3' border='2px solid white' width={'20'} /> */}
          <SimpleGrid gap={"10"} mt="5" columns={{ base: "3", md: "5" }}>
            <Box>
              <IoLogoJavascript size="32" color="yellow" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                JavaScript
              </Text>
            </Box>
            <Box>
              <SiTypescript size="32" color="#007ACC" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                TypeScript
              </Text>
            </Box>
            <Box>
              <IoLogoReact size="32" color="#06BCEE" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                React
              </Text>
            </Box>
            <Box>
              <TbBrandReactNative size="32" color="#61DAFB" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                React Native
              </Text>
            </Box>
            <Box>
              <SiNextdotjs size="32" color="#000000" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                Next.js
              </Text>
            </Box>
            <Box>
              <SiPhp size="32" color="#4F5B93" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                PHP
              </Text>
            </Box>
            <Box>
              <SiChakraui size="32" color="#60CACB" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                Chakra Ui
              </Text>
            </Box>
            <Box>
              <IoLogoHtml5 size="32" color="#F75421" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                HTML
              </Text>
            </Box>
            <Box>
              <FaCss3 size="32" color="#016DB5" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                CSS
              </Text>
            </Box>
            <Box>
              <SiTailwindcss size="32" color="#39BDF8" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                Tailwind
              </Text>
            </Box>
            <Box>
              <SiRedux size="32" color="#855FC3" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                Redux
              </Text>
            </Box>
            <Box>
              <FaNodeJs size="32" color="#4CAF50" />
              {/* <Image src={Node} objectFit={'fill'} /> */}
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                NodeJs
              </Text>
            </Box>
            <Box>
              <SiMongodb size="32" color="#00684A" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                MongoDB
              </Text>
            </Box>
            <Box>
              <SiMysql size="40" color="#005A85" />
              <Text fontSize={"14"} color="white" fontWeight={"medium"}>
                MySQL
              </Text>
            </Box>
          </SimpleGrid>
        </Box>
      </Flex>
    </Box>
  );
};
